import React from 'react';

import { StyledListItem } from './StyledComponents';

export const ListItem = ({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement => <StyledListItem>{children}</StyledListItem>;
